import { postAuthRequest } from './post'

export const combineLeadRequest = (parent: number, children: Array<number>) => {
  return postAuthRequest(`lead-children/`, { parent, children })
}
